"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftRatingDto = instanceOfShiftRatingDto;
exports.ShiftRatingDtoFromJSON = ShiftRatingDtoFromJSON;
exports.ShiftRatingDtoFromJSONTyped = ShiftRatingDtoFromJSONTyped;
exports.ShiftRatingDtoToJSON = ShiftRatingDtoToJSON;
exports.ShiftRatingDtoToJSONTyped = ShiftRatingDtoToJSONTyped;
const ShiftRatingMetric_1 = require("./ShiftRatingMetric");
/**
 * Check if a given object implements the ShiftRatingDto interface.
 */
function instanceOfShiftRatingDto(value) {
    if (!('metric' in value) || value['metric'] === undefined)
        return false;
    if (!('rating' in value) || value['rating'] === undefined)
        return false;
    return true;
}
function ShiftRatingDtoFromJSON(json) {
    return ShiftRatingDtoFromJSONTyped(json, false);
}
function ShiftRatingDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'metric': (0, ShiftRatingMetric_1.ShiftRatingMetricFromJSON)(json['metric']),
        'rating': json['rating'],
    };
}
function ShiftRatingDtoToJSON(json) {
    return ShiftRatingDtoToJSONTyped(json, false);
}
function ShiftRatingDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'metric': (0, ShiftRatingMetric_1.ShiftRatingMetricToJSON)(value['metric']),
        'rating': value['rating'],
    };
}
//# sourceMappingURL=ShiftRatingDto.js.map